import {Type} from "../../helper";
import {select} from "../../../../shared/SagaService";
import dayjs from 'dayjs';
import {CustomFieldHelper} from "../../../../shared/CustomFieldHelper";

const Date = date => (date ? dayjs(date) : undefined);

// Helper Function
function* getInitFormData(transaction, transactionType) {
    const showShipping = yield select(state => state.Transaction.showShipping);

    // Common
    const {
        contact_id,
        contact2_id,
        number,
        number2,
        account_id,
        account2_id,
        currency_code,
        exchange_rate,
        amount,
        title,
        tax_mode,
        description,
        internal_note,
        billing_party,
        shipping_info,
        shipping_party,
        // payment_method_id,
        term_id,
        tag_ids,
        status,
        remarks,

        // Only for myinvois and Malaysian companies
        customs_form_no,
        customs_k2_form_no,
        incoterms,
    } = transaction;
    const date = Date(transaction.date);

    const myinvois_action = transaction.myinvois_action || 'NORMAL';

    // Here we fill in the cp_id with the cp name, so that the name will be directly populated
    // onto the form. The cp id will be updated to store in redux in updateStore.js
    const billing_cp = transaction.billing_contact_person;
    const shipping_cp = transaction.shipping_contact_person;

    switch (transactionType) {
        case Type.sale_quote:
            return {
                // General
                contact_id,
                billing_party,
                billing_contact_person_id_or_name: billing_cp,
                title,
                show_shipping: showShipping,
                shipping_info,
                shipping_party,
                shipping_contact_person_id_or_name: shipping_cp,
                term_id,
                number,
                number2,
                date,
                currency_code,
                exchange_rate,
                tag_ids,
                tax_mode,
                rounding_on: transaction.rounding_on,

                description,
                internal_note,
                remarks,
                status,

                // Fields
                ...CustomFieldHelper.initFormData(transaction),
            };
        case Type.sale_order:
            return {
                // General
                contact_id,
                billing_party,
                billing_contact_person_id_or_name: billing_cp,
                title,
                show_shipping: showShipping,
                shipping_info,
                shipping_party,
                shipping_contact_person_id_or_name: shipping_cp,
                term_id,
                number,
                number2,
                date,
                currency_code,
                exchange_rate,
                tag_ids,
                tax_mode,
                rounding_on: transaction.rounding_on,
                description,
                internal_note,
                remarks,
                status,

                ...CustomFieldHelper.initFormData(transaction),
            };
        case Type.sale_delivery_order:
            return {
                // General
                contact_id,
                title,
                billing_party,
                billing_contact_person_id_or_name: billing_cp,
                shipping_info,
                shipping_party,
                shipping_contact_person_id_or_name: shipping_cp,
                number,
                number2,
                date,
                currency_code,
                exchange_rate,
                tag_ids,

                // Item
                tax_mode,
                rounding_on: transaction.rounding_on,

                // Others
                remarks,
                description,
                internal_note,
                status,

                ...CustomFieldHelper.initFormData(transaction),
            };
        case Type.sale_invoice: {
            const paymentMode = yield select(state => state.Transaction.paymentMode);

            const formData = {
                // General
                payment_mode: transaction.payment_mode,
                contact_id,
                group_id: transaction.group_id,
                contact_and_group_id: transaction.contact_and_group_id,
                title,
                billing_party,
                billing_contact_person_id_or_name: billing_cp,
                shipping_info,
                shipping_party,
                shipping_contact_person_id_or_name: shipping_cp,
                number,
                number2,
                date,
                currency_code,
                exchange_rate,
                tag_ids,

                // Item
                tax_mode,
                rounding_on: transaction.rounding_on,

                // Others
                remarks,
                description,
                internal_note,
                status,

                customs_form_no,
                customs_k2_form_no,
                incoterms,
                myinvois_action,

                ...CustomFieldHelper.initFormData(transaction),
            };

            // Term
            if (paymentMode !== 'credit') {
                formData.account_id = transaction.account_id || undefined;
                formData.payment_method_id = transaction.payment_method_id || undefined;
                formData.payment_number = transaction.payment_number;
            }
            return formData;
        }
        case Type.sale_credit_note:
            return {
                // General
                contact_id,
                title,
                billing_party,
                billing_contact_person_id_or_name: billing_cp,
                shipping_info,
                shipping_party,
                shipping_contact_person_id_or_name: shipping_cp,
                number,
                number2,
                date,
                currency_code,
                exchange_rate,
                tag_ids,

                // Item
                tax_mode,
                rounding_on: transaction.rounding_on,

                links: {},
                // Others
                remarks,
                description,
                internal_note,
                status,

                customs_form_no,
                customs_k2_form_no,
                incoterms,
                myinvois_action,

                ...CustomFieldHelper.initFormData(transaction),
            };
        case Type.sale_payment:
            return {
                // General
                contact_id,
                billing_party,
                billing_contact_person_id_or_name: billing_cp,
                number,
                number2,
                date,
                currency_code,
                exchange_rate,
                tag_ids,
                // amount,
                // account_id,
                // account2_id,
                // fee_amount: transaction.fee_amount ? Number(transaction.fee_amount).toFixed(2) : undefined,
                // payment_method_id,
                description,
                internal_note,
                remarks,
                status,

                ...CustomFieldHelper.initFormData(transaction),
            };
        case Type.sale_refund:
            return {
                contact_id,
                number,
                number2,
                date,
                currency_code,
                exchange_rate,
                tag_ids,

                billing_party,
                billing_contact_person_id_or_name: billing_cp,
                // account_id,
                // account2_id,
                // fee_amount: transaction.fee_amount ? Number(transaction.fee_amount).toFixed(2) : undefined,
                // payment_method_id,
                description,
                internal_note,
                remarks,
                status,

                ...CustomFieldHelper.initFormData(transaction),
            };
        case Type.purchase_order:
            return {
                contact_id,
                billing_party,
                billing_contact_person_id_or_name: billing_cp,
                title,
                show_shipping: showShipping,
                shipping_info,
                shipping_party,
                shipping_contact_person_id_or_name: shipping_cp,
                term_id,
                number,
                number2,
                date,
                currency_code,
                exchange_rate,
                tag_ids,
                tax_mode,
                rounding_on: transaction.rounding_on,

                description,
                internal_note,
                remarks,
                status,

                ...CustomFieldHelper.initFormData(transaction),
            };
        case Type.purchase_goods_received_note:
            return {
                // General
                contact_id,
                title,
                billing_party,
                billing_contact_person_id_or_name: billing_cp,
                shipping_info,
                shipping_party,
                shipping_contact_person_id_or_name: shipping_cp,
                number,
                number2,
                date,
                currency_code,
                exchange_rate,
                tag_ids,

                // Item
                tax_mode,
                rounding_on: transaction.rounding_on,

                // Others
                remarks,
                description,
                internal_note,
                status,

                ...CustomFieldHelper.initFormData(transaction),
            };
        case Type.purchase_bill:
            return {
                payment_mode: transaction.payment_mode,
                billing_party,
                billing_contact_person_id_or_name: billing_cp,
                shipping_info,
                shipping_party,
                shipping_contact_person_id_or_name: shipping_cp,
                contact_id,
                contact2_id,
                number,
                number2,
                date,
                term_id,
                due_date: Date(transaction.due_date),
                // due_date: transaction.due_date?.format("YYYY-MM-DD"),
                currency_code,
                exchange_rate,
                tag_ids,

                account_id,
                payment_method_id: transaction.payment_method_id,
                payment_number: transaction.payment_number,

                tax_mode,
                rounding_on: transaction.rounding_on,

                remarks,
                description,
                internal_note,
                status,

                customs_form_no,
                customs_k2_form_no,
                incoterms,
                myinvois_action,

                ...CustomFieldHelper.initFormData(transaction),
            };
        case Type.purchase_credit_note:
            return {
                contact_id,
                billing_party,
                billing_contact_person_id_or_name: billing_cp,
                shipping_info,
                shipping_party,
                shipping_contact_person_id_or_name: shipping_cp,
                number,
                number2,
                date,
                currency_code,
                exchange_rate,
                tag_ids,
                tax_mode,
                rounding_on: transaction.rounding_on,
                description,
                internal_note,
                remarks,
                status,

                customs_form_no,
                customs_k2_form_no,
                incoterms,
                myinvois_action,

                ...CustomFieldHelper.initFormData(transaction),
            };
        case Type.purchase_payment:
            return {
                contact_id,
                billing_party,
                billing_contact_person_id_or_name: billing_cp,
                number,
                number2,
                date,
                currency_code,
                exchange_rate,
                // amount,
                // account_id,
                // account2_id,
                // fee_amount: transaction.fee_amount ? Number(transaction.fee_amount).toFixed(2) : undefined,
                // payment_method_id,
                tag_ids,
                description,
                internal_note,
                remarks,
                status,

                ...CustomFieldHelper.initFormData(transaction),
            };
        case Type.purchase_refund:
            return {
                contact_id,
                number,
                number2,
                date,
                currency_code,
                exchange_rate,
                billing_party,
                billing_contact_person_id_or_name: billing_cp,
                // account_id,
                // account2_id,
                // fee_amount: transaction.fee_amount ? Number(transaction.fee_amount).toFixed(2) : undefined,
                // payment_method_id,
                tag_ids,
                description,
                internal_note,
                remarks,
                status,

                ...CustomFieldHelper.initFormData(transaction),
            };
        case Type.bank_income:
            return {
                // General
                contact_id,
                billing_party,
                billing_contact_person_id_or_name: billing_cp,
                number,
                number2,
                date,
                currency_code,
                exchange_rate,
                // account_id,
                // account2_id,
                // fee_amount: transaction.fee_amount ? Number(transaction.fee_amount).toFixed(2) : undefined,
                // payment_method_id,
                tag_ids,
                tax_mode,
                rounding_on: transaction.rounding_on,

                description,
                internal_note,
                remarks,
                status,

                // Fields
                ...CustomFieldHelper.initFormData(transaction),
            };
        case Type.bank_expense:
            return {
                // General
                contact_id,
                billing_party,
                billing_contact_person_id_or_name: billing_cp,
                number,
                number2,
                date,
                currency_code,
                exchange_rate,
                // account_id,
                // account2_id,
                // fee_amount: transaction.fee_amount ? Number(transaction.fee_amount).toFixed(2) : undefined,
                // payment_method_id,
                tag_ids,
                tax_mode,
                rounding_on: transaction.rounding_on,

                description,
                internal_note,
                remarks,
                status,

                // Fields
                ...CustomFieldHelper.initFormData(transaction),
            };
        case Type.bank_transfer:
            return {
                number,
                number2,
                date,
                currency_code,
                exchange_rate,
                account_id,
                account2_id,
                amount,
                tag_ids,
                description,
                internal_note,
                remarks,
                status,
            };
        case Type.stock_adjustment:
            return {
                general: {
                    account_id,
                    description,
                    number,
                    number2,
                    date,
                    tag_ids,
                },
                status,
                remarks,
                description,
                internal_note,
            };
        case Type.stock_transfer:
            return {
                general: {
                    number,
                    number2,
                    date,
                },
                status,
                description,
                internal_note,
                remarks,
            };
        case Type.contra:
            return {
                contact_id,
                contact2_id,
                date,
                number,
                number2,
                currency_code,
                exchange_rate,
                tag_ids,
                description,
                internal_note,
                remarks,
                status,
            };
        case Type.journal_entry:
            return {
                contact_id,
                number,
                number2,
                date,
                currency_code,
                exchange_rate,
                tag_ids,
                description,
                internal_note,
                remarks,
                status,
            };
        case Type.tax_deemed_payment: {
            const formData = {
                // General
                number,
                number2,
                date,
                currency_code,
                exchange_rate,
                tag_ids,
                description,
                internal_note,
                remarks,
                status,
            };

            if (transaction.link_items) {
                transaction.link_items.forEach(item => {
                    formData[`apply_amount_${item.target_transaction_id}`] = item.apply_amount;
                });
            }

            return formData;
        }
        case Type.opening_invoice:
        case Type.opening_bill:
        case Type.opening_sale_credit_note:
        case Type.opening_purchase_credit_note:
        default:
            return {};
    }
}

// Main Function
export function* updateForm(transaction, transactionType, form) {
    const formData = yield getInitFormData(transaction, transactionType);
    console.log('aaa updateForm', formData);
    form?.setFieldsValue?.(formData);
}
